import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Flashlight"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-flashlight',
    templateUrl: './icon-flashlight.component.html',
    styleUrls: ['./icon-flashlight.component.scss'],
    standalone: false
})
export class IconFlashlightComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
